import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useModal } from '~shared/components/modal-overlay/ModalContext';

const ModalWindow = ({
        children,
        gtmTag,
        handleClose,
        title,
        hideLogo,
        modalOverrideClass,
        iconClass,
    }) => {
    const { popModal } = useModal();
    const closeModal = handleClose || popModal;

    return (
        <>
            <div className='modal-overlay__close-modal' onClick={closeModal} data-spectate-product={gtmTag} />
            <div className={`modal-overlay__window ${modalOverrideClass}`}
                data-testid="modal-window"
            >
                <div className='modal-overlay__window__top-bar'>
                <div className={
                    classNames(
                        'modal-overlay__window__top-bar__logo',
                        {
                            [iconClass]: !hideLogo,
                            'modal-overlay__window__top-bar__logo--hide': hideLogo,
                        }
                    )}/>
                    {title &&
                        <div className='modal-overlay__window__top-bar__title'>{title}</div>
                    }
                    <button className='modal-overlay__window__top-bar__close-btn' onClick={closeModal} data-spectate-product={gtmTag}/>
                </div>
                <div className='modal-overlay__window__content'>
                    {children}
                </div>
            </div>
        </>
    );
};

ModalWindow.propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    gtmTag: PropTypes.string,
    handleClose: PropTypes.func,
    modalOverrideClass: PropTypes.string,
    title: PropTypes.string,
    hideLogo: PropTypes.bool,
    iconClass: PropTypes.string,
};

ModalWindow.defaultProps = {
    gtmTag: '',
    handleClose: null,
    modalOverrideClass: '',
    title: '',
    hideLogo: false,
    iconClass: 'brand-logo',
};

export default ModalWindow;
